import React from 'react'

interface ElementListProps<T> {
  children: (item: T) => React.ReactNode
  dir: 'horizontal' | 'vertical'
  dividers?: boolean
  items: T[]
  windowing?: boolean
}

interface IdObj {
  id: string | number
}

export const ElementList = <T extends IdObj>({
  children,
  items
}: ElementListProps<T>) => {
  const elements = items.map((item) => (
    <div key={item.id} className='item'>
      {children(item)}
    </div>
  ))

  return <React.Fragment>{elements}</React.Fragment>
}
